import { render, staticRenderFns } from "./CrudList.vue?vue&type=template&id=09398c7a&scoped=true&"
import script from "./CrudList.vue?vue&type=script&lang=js&"
export * from "./CrudList.vue?vue&type=script&lang=js&"
import style0 from "./CrudList.vue?vue&type=style&index=0&id=09398c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09398c7a",
  null
  
)

export default component.exports